/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const productConfig = {
  products: [
    {
      id: 1,
      banner: 'https://i.ibb.co/WGJpp07/cover-1.jpg',
    },
    {
      id: 2,
      banner: 'https://i.ibb.co/1QsjKKN/cover-2.jpg',
    },
    {
      id: 3,
      banner: 'https://i.ibb.co/zPY2ByK/cover-3.jpg',
    },
    {
      id: 4,
      banner: 'https://i.ibb.co/0JYXgc1/cover-4.jpg',
    },
    {
      id: 5,
      banner: 'https://i.ibb.co/WGJpp07/cover-1.jpg',
    },
    {
      id: 6,
      banner: 'https://i.ibb.co/1QsjKKN/cover-2.jpg',
    },
    {
      id: 7,
      banner: 'https://i.ibb.co/zPY2ByK/cover-3.jpg',
    },
    {
      id: 8,
      banner: 'https://i.ibb.co/0JYXgc1/cover-4.jpg',
    },
    {
      id: 9,
      banner: 'https://i.ibb.co/0JYXgc1/cover-4.jpg',
    },
    {
      id: 10,
      banner: 'https://i.ibb.co/WGJpp07/cover-1.jpg',
    },
    {
      id: 11,
      banner: 'https://i.ibb.co/1QsjKKN/cover-2.jpg',
    },
    {
      id: 12,
      banner: 'https://i.ibb.co/zPY2ByK/cover-3.jpg',
    },
    {
      id: 13,
      banner: 'https://i.ibb.co/0JYXgc1/cover-4.jpg',
    },
    {
      id: 14,
      banner: 'https://i.ibb.co/WGJpp07/cover-1.jpg',
    },
    {
      id: 15,
      banner: 'https://i.ibb.co/1QsjKKN/cover-2.jpg',
    },
    {
      id: 16,
      banner: 'https://i.ibb.co/zPY2ByK/cover-3.jpg',
    },
    {
      id: 17,
      banner: 'https://i.ibb.co/0JYXgc1/cover-4.jpg',
    },
  ],
};
